export const ArrowRight = () => (
  <svg
    width="9"
    height="8"
    viewBox="0 0 9 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.47656 3.72656V4.29688L1.25781 7.46875L0.96875 6.76562L7.27344 4.01562L0.96875 1.25781L1.25781 0.554688L8.47656 3.72656Z"
      fill="#666666"
    />
  </svg>
);

export default ArrowRight;
